import { validateZipCode } from "@remar/shared/dist/utils/validateZipCode";
import * as Yup from "yup";

export const BillingAddressSchema = Yup.object().shape({
	countryId: Yup.number().required("Required"),
	address1: Yup.string().required("Required"),
	address2: Yup.string().optional(),
	city: Yup.string().min(2).required("Required"),
	state: Yup.string().min(2).required("Required"),
	zipCode: validateZipCode(Yup).max(10).required("Required"),
	fullName: Yup.string().required("Required"),
	phoneNumber: Yup.string()
		.max(20, "Phone number must be at most 20 characters")
		.min(7, "Phone number must be at least 7 characters")
		.required("Required")
		.matches(/^\+?\d(\-?)(.[^+]*[0-9])?$/g, "Please enter valid phone number")
});
